import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { RouteSuspense } from './routes/RouteSuspense';
import { AppProvider } from './utils/state';
import { MsalProvider, useMsal } from '@azure/msal-react';
import { AuthProvider, msalInstance } from './libs/auth';
const PrivateRoutes = React.lazy(() => import('./routes/PrivateRoutes'));
const PublicRoutes = React.lazy(() => import('./routes/PublicRoutes'));

const AuthCheck = () => {
  const { accounts } = useMsal();

  if (accounts.length > 0) {
    return <PrivateRoutes />;
  }

  return <PublicRoutes />;
};

const App = () => {
  return (
    <MsalProvider instance={msalInstance}>
      <AuthProvider>
        <AppProvider>
          <Routes>
            <Route
              path="/*"
              element={
                <RouteSuspense>
                  <AuthCheck />
                </RouteSuspense>
              }
            />
          </Routes>
        </AppProvider>
      </AuthProvider>
    </MsalProvider>
  );
};

export default App;
